"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clamp = void 0;
function clamp(value, minValue, maxValue) {
    if (minValue !== undefined && value < minValue)
        return minValue;
    if (maxValue !== undefined && value > maxValue)
        return maxValue;
    return value;
}
exports.clamp = clamp;
//# sourceMappingURL=clamp.js.map